<nz-row nzJustify="space-between" nzAlign="middle">
  <nz-col style="margin-bottom: 10px;">
    <!--  [(ngModel)]="searchText" (ngModelChange)="onSearch()" -->
    <input nz-input placeholder="Search..." [(ngModel)]="searchText" (change)="onSearch($event)" />
  </nz-col>
  <nz-col>

     <button nz-button nzType="default" (click)="getClientPPT()"
    [disabled]="!isSelectedAny()">Generate PPT</button>


    <button nz-button nzType="default" (click)="compareQuotations()"
    [disabled]="!isComparable()" style="margin-left: 10px;">Compare</button>

  </nz-col>
</nz-row>

<nz-spin [nzSpinning]="loading" [nzTip]="'Loading data...'">
  <div class="table-wrapper">
    <nz-table
      [nzData]="quotationList"
      [nzBordered]="true"
      [nzSize]="'middle'"
      [nzShowPagination]="false"
      [nzScroll]="{ x: '1500px' }"
    >
    <thead>
      <tr>
        <!-- <th>
          <nz-checkbox
          [nzChecked]="allChecked"
          [nzIndeterminate]="indeterminate"
          (change)="onAllChecked($event.target.checked)"
        ></nz-checkbox>
        </th> -->
        <!-- this is from offcial doc -->
        <th [nzChecked]="allChecked" [nzIndeterminate]="indeterminate" nzLabel="Select all"
          (nzCheckedChange)="onAllChecked($event)" nzWidth="60px"></th>
        <th nzWidth="90px">ID</th>
        <th nzWidth="200px">Type</th>
        <th nzWidth="200px">Vendor</th>
        <!-- <th>Quoted Amount</th> -->
        <th nzWidth="120px">Shortlisted</th>
        <th nzWidth="120px">Finalized</th>
        <th nzWidth="120px">View</th>
        <th nzWidth="160px">Remarks</th>
        <th nzWidth="180px">Submitted At</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of quotationList; trackBy: trackById">
        <!-- <td >
          <nz-checkbox
          [(ngModel)]="item.checked"
          [disabled]="item.disabled"
          (ngModelChange)="onItemChecked(item, $event)"
        ></nz-checkbox>
        </td> -->

        <!-- this is from offcial doc -->
         <td [nzChecked]="item.checked" [nzDisabled]="item.disabled" [nzLabel]="item.name ? item.name: 'No Label'"
          (nzCheckedChange)="onItemChecked(item, $event)"></td>

        <td> <nz-tag> {{ formatIdToFourDigits(item.id) }}</nz-tag> </td>

         <td>
          <div class="type-cell">
            <img nz-image height="30px" [nzSrc]="getOursouringTypeImage(item)" alt="brand-image-{{item.id}}"
              [nzFallback]="sampleFallbackImage" />
            <span style="margin-left: 5px;">
              {{ getOursouringTypeName(item) }}
            </span>
          </div>
        </td>


        <td style="font-weight: 600;"><a href="javascript:void(0)" (click)="onVendorDetails(item?.quotation_request_vendor_details?.vendor_details?.id)">  {{ item?.quotation_request_vendor_details?.vendor_details?.name }} </a></td>



        <!-- <td>{{ item.amount | currency }}</td> -->
        <td>
          <nz-tag [nzColor]="item.quotation_request_vendor_details?.is_shortlisted ? 'green' : 'red'">
            {{ item.quotation_request_vendor_details?.is_shortlisted ? 'Yes' : 'No' }}
          </nz-tag>
        </td>
        <td>
          <nz-tag [nzColor]="item.quotation_request_vendor_details?.is_finalized ? 'green' : 'red'">
            {{ item.quotation_request_vendor_details?.is_finalized ? 'Yes' : 'No' }}
          </nz-tag>
        </td>

         <td>
           <button  nz-button nzType="default" nzSize="small"  (click)="viewVendorSubmission(item)"
            nz-tooltip [nzTooltipTitle]="'View details'" nzTooltipPlacement="top">
            <nz-icon nzType="eye" nzTheme="outline" /> View
          </button>
        </td>

        <td>
            <span nz-tooltip [nzTooltipTitle]="item.overall_submission_notes" nzTooltipPlacement="left">
                        {{ item.overall_submission_notes.length > 20 ?
                        item.overall_submission_notes.substring(0, 20) + '...' :
                        item.overall_submission_notes }}
                    </span>

      </td>
        <td>{{item?.submitted_at | date:'medium'}}</td>
      </tr>
    </tbody>
    </nz-table>
  </div>
</nz-spin>

<ng-template #compareQuatationModalTitle>
  <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
    <h3 style="margin: 0; color: #3f0c9e;">
      <i nz-icon nzType="bar-chart" nzTheme="outline" style="margin-right: 8px;"></i>
      Detailed Quotation Comparison
    </h3>

    <button nz-button nzType="text" nzShape="circle" (click)="closeModal($event, 'compareQuotations')">
      <i nz-icon nzType="close" nzTheme="outline"></i>
    </button>
  </div>
</ng-template>


<ng-template #getPPTModalModalTitle>
  <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
    <h3 style="margin: 0; color: #3f0c9e;">
      <nz-icon nzType="file-ppt" nzTheme="outline" style="margin-right: 8px;"/>
      Generate PPT
    </h3>

    <div style="font-size: 10px; font-style: italic;">
        <nz-alert nzType="warning"
   nzMessage="This data will not be saved. Closing the window will discard all entered information."
   nzShowIcon></nz-alert>
    </div>

    <button nz-button nzType="text" nzShape="circle" (click)="closeModal($event, 'getClientPPT')">
      <i nz-icon nzType="close" nzTheme="outline"></i>
    </button>
  </div>
</ng-template>
